module.exports = __webpack_public_path__ + "img/brother.be5030ca.webp";